// import Vuelidate from 'vuelidate'
import AnimationManager from '../scripts/AnimationManager'
import entry from './index'
import store from './../store/main'

AnimationManager.init()
entry(store, 'main', /* { plugins: [Vuelidate] } */)
